import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'

export default function Member_details() {
    const navigate = useNavigate();
    const [listProjectArray, setListProjectArray] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        let memberid = localStorage.getItem('selectedComMemberID');
        var obj = {
            mem_id: memberid
        }
        console.log(obj);
        $.ajax({
            type: 'POST',
            url: 'getMemberDetails.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                if (res !== 'fail' && res !== '') {
                    $('#memname').text(res[0].mem_fname + ' ' + res[0].mem_lname);
                    $('#comname').text(res[0].company_name);
                    $('#countname').text(res[0].country);
                    $('#explist').text(res[0].expertise);
                    $('#activests').text(res[0].mem_activation);
                    $('#mememail').text(res[0].mem_email);
                    $('#mem_phone').text(res[0].mem_phone);
                    $('#mem_role').text(res[0].mem_role);
                    $('#regdate').text(res[0].reg_dt_tm);
                    getMemberProjectDetails(memberid);

                } else {
                    showAlert('Cannot find any details.');
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", status, error, xhr.responseText);
            }
        });

    }, [])

    function getMemberProjectDetails(id) {
        var obj = {
            userid: id
        }
        $.ajax({
            type: 'POST',
            url: 'getMembersProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });
    }
    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='tabs' >Details of <span id="memname"></span></h2>
                    <button
                        className="pull_right add_new_pro"
                        onClick={() => navigate(-1)}
                    >
                        Back to list
                    </button>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='detailsarea'>
                        <h2 className='details_heading'>General Information</h2>
                        <p className='details_item'>Company Name: <span id="comname"></span></p>
                        <p className='details_item'>Country: <span id="countname"></span></p>
                        <p className='details_item'>Expertise: <span id="explist"></span></p>
                        <p className='details_item'>Activation: <span id="activests"></span></p>
                        <p className='details_item'>Email: <span id="mememail"></span></p>
                        <p className='details_item'>Phone: <span id="mem_phone"></span></p>
                        <p className='details_item'>Role: <span id="mem_role"></span></p>
                        <p className='details_item'>Registration Date: <span id="regdate"></span></p>
                    </div>
                    <div className='detailsarea'>
                        <h2 className='details_heading'>Project Information</h2>
                        <div className='vl_listing_area'>
                            <div className='vl_listing_row'>
                                <div className='vl_listing_cell width20'>
                                    <h4 className='prj_name'>Project Name</h4>
                                </div>
                                <div className='vl_listing_cell width20'>
                                    <p>Role</p>
                                </div>


                                <div className='vl_listing_cell width10'>
                                    <p>Accept</p>
                                </div>
                                <div className='vl_listing_cell width20'>
                                    <p>Deadline</p>
                                </div>
                                <div className='vl_listing_cell width20'>
                                    <p>Status</p>
                                </div>
                            </div>
                            {listProjectArray.map((item, index) => {
                                const activestatus = item.project_status === 'active';
                                const acceptpro = item.accept;
                                if (!activestatus) return null; // skip inactive items

                                return (
                                    <div className='vl_listing_row' key={index}>
                                        <div className='vl_listing_cell width20'>
                                            <h4 className='prj_name'>{item.pro_name}</h4>

                                        </div>

                                        <div className='vl_listing_cell width20 hig120 prdetails'>
                                            <p>{item.member_role}</p>

                                        </div>

                                        <div className='vl_listing_cell width10'>
                                            <p>{item.accept}</p>
                                        </div>

                                        <div className='vl_listing_cell width20'>
                                            <p>{item.pr_last_date}</p>
                                        </div>

                                        <div className='vl_listing_cell width20'>
                                            <p>{item.project_status}</p>
                                        </div>


                                    </div>
                                );
                            })}

                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
